import { render, staticRenderFns } from "./BaseSearchDropdown.vue?vue&type=template&id=4e798896&scoped=true&"
import script from "./BaseSearchDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseSearchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchDropdown.vue?vue&type=style&index=0&id=4e798896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e798896",
  null
  
)

export default component.exports